import { ConceptRow as ConceptRow$2 } from './ConceptRow.style.js';
import { jsx } from 'react/jsx-runtime';

var ConceptRow = function ConceptRow(_ref) {
  var conceptRowText = _ref.conceptRowText;
  return /*#__PURE__*/jsx(ConceptRow$2, {
    children: conceptRowText
  });
};
var ConceptRow$1 = ConceptRow;

export { ConceptRow$1 as default };
//# sourceMappingURL=ConceptRow.js.map
